import React, { Component } from 'react';
import classNames from 'classnames';

class DistrictsLegend extends Component {
  render() {
    const legendItems = [];
    let i = 0;

    while(i < 3) {
      let districtClass;
      let a;
      let b;

      if(this.props[`district-${i}`]){
        a = this.props[`district-${i}`].a;
        b = this.props[`district-${i}`].b;
      }

      if(this.props[`district-${i}`] && a + b === this.props.num_squares){
        if (a > b){
          districtClass = 'gm-slide__your-districts--district-a';
        }

        if (a < b){
          districtClass = 'gm-slide__your-districts--district-b';
        }

        if (a === b){
          districtClass = 'gm-slide__your-districts--district-eq';
        }
      }

      if(this.props[`district-${i}`] && a === this.props.num_squares){
        districtClass = 'gm-slide__your-districts--district-a';
      }

      if(this.props[`district-${i}`] && b === this.props.num_squares){
        districtClass = 'gm-slide__your-districts--district-b';
      }

      const itemClasses = classNames( 'gm-slide__your-districts', 'gm-slide__your-districts-legend', districtClass );

      legendItems.push(<div key={ i } className={ itemClasses }></div>);
      i++;
    }

    return (
      <div className="gm-slide__your-districts">
        <div className="gm-slide__your-districts-label">Your Districts</div>
        { legendItems }
      </div>
    );
  }
}

export default DistrictsLegend;



// WEBPACK FOOTER //
// ./src/components/Shared/DistrictsLegend.js